/* import __COLOCATED_TEMPLATE__ from './client-predicates-editor.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { copy } from 'ember-copy';

export default class ClientPredicatesEditor extends Component {
  @service contentEditorService;
  @service store;

  get canUseWorkflowDraftStateForInbound() {
    let customBot = this.contentEditorService.activeObject;
    return customBot?.canUseWorkflowDraftStateForInbound?.() && customBot.activeWorkflow;
  }

  get currentClientPredicateGroup() {
    if (this.canUseWorkflowDraftStateForInbound) {
      return (
        this.contentEditorService.activeObject.activeWorkflow.additionalData.clientPredicateGroup ||
        this.args.ruleset.clientPredicateGroup
      );
    }
    return this.args.ruleset.clientPredicateGroup;
  }

  @action onUpdateClientPredicates(predicates) {
    // For inbound workflows with draft enabled, update draft workflow's additionalData
    if (this.canUseWorkflowDraftStateForInbound) {
      let workflow = this.contentEditorService.activeObject.activeWorkflow;
      let additionalData = workflow.additionalData;

      // Ensure clientPredicateGroup exists
      if (!additionalData.clientPredicateGroup) {
        additionalData.set(
          'clientPredicateGroup',
          this.store.createFragment('predicates/predicate-group'),
        );
      }

      // Set just the predicates array (not the whole group)
      additionalData.set('clientPredicateGroup.predicates', copy(predicates));

      workflow.hasBeenEdited = true;
      workflow.notifyPropertyChange('additionalData');
      workflow.notifyPropertyChange('hasUnsavedChanges');
    } else {
      // For live mode or non-inbound workflows, update ruleset directly
      this.args.ruleset.set('clientPredicateGroup.predicates', copy(predicates));
    }
  }
}
